import { getEstimateNumberValueBasedOnSettings } from "@Actions/estimation";
import { Chip } from "@mui/material";
import { useSelector } from "react-redux";
import type { RootState } from "src/reducers";
import type { EstimateData as EstimateDataState } from "@ServerTypes/estimates/estimates.schema";

type BoqItemQuantityChipProps = {
  // `null` is accepted because the BOQ row shape exposes these fields as
  // nullable; the component already coerces null via `String(... ?? "")`.
  manualQuantity?: number | string | null;
  quantityFromTakeoffs?: number | string | null;
  isDefaultZero?: boolean;
};

const BoqItemQuantityChip = ({
  manualQuantity: manualQuantityProp,
  quantityFromTakeoffs: quantityFromTakeoffsProp,
  isDefaultZero = false,
}: BoqItemQuantityChipProps) => {
  const estimateData = useSelector((state: RootState) => state.estimateData) as EstimateDataState;

  let manualQuantity = parseFloat(String(manualQuantityProp ?? ""));
  let quantityFromTakeoffs = parseFloat(String(quantityFromTakeoffsProp ?? ""));
  if (isNaN(manualQuantity) && (isNaN(quantityFromTakeoffs) || quantityFromTakeoffs === 0)) {
    return isDefaultZero ? 0 : <div>-</div>;
  }
  manualQuantity = manualQuantity || 0;
  quantityFromTakeoffs = quantityFromTakeoffs || 0;
  const totalQuantity = () =>
    getEstimateNumberValueBasedOnSettings(
      Number(manualQuantity) + Number(quantityFromTakeoffs),
      estimateData,
      "quantity",
    );
  let bgColor = "bg-surface_white";
  let textColor = "text-primary_text";
  if (Number(manualQuantity) > 0 && Number(quantityFromTakeoffs) > 0) {
    bgColor = "bg-gradient_color";
    textColor = "text-surface_white";
  } else if (Number(quantityFromTakeoffs) > 0 && Number(manualQuantity) === 0) {
    bgColor = "bg-system_colour_24";
    textColor = "text-surface_white";
  }
  return estimateData._id ? (
    <Chip
      label={totalQuantity()}
      className={`h-6 ${bgColor} ${textColor} rounded-2xl px-2 py-1 w-auto min-w-fit`}
      sx={{
        "& .MuiChip-label": {
          padding: 0,
        },
      }}
    />
  ) : null;
};

export default BoqItemQuantityChip;
